module.exports = __webpack_public_path__ + "static/media/porte6.6ad1ded9.jpg";